import React from 'react';
import { Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import { Box } from 'rebass';
import { string } from 'prop-types';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import UnderlineNavigation from '../../../components/UnderlineNavigation';
import LinkedCatalogs from './LinkedCatalogs';
import LinkedAccounts from './LinkedAccounts';

import { columnSortModifiersLinkedCatalogs, columnFilterModifiersLinkedCatalogs } from './linkedCatalogsColumns';
import {
  columnSortModifiersLinkedAccounts,
  columnFilterModifiersLinkedAccounts
} from '../../productContracts/LinkedContractsAndAccounts/linkedAccountsColumns';

const LinkedCatalogsAndAccounts = ({ catalogTypeId }) => {
  const { url, path } = useRouteMatch();
  const { pathname } = useLocation();

  const initialActiveTab = pathname.indexOf('linkedAccounts') !== -1 ? 1 : 0;

  return (
    <Box>
      <Box mt='5px'>
        <UnderlineNavigation
          list={[
            { title: 'Linked Catalogs', href: `${url}/linkedCatalogs` },
            { title: 'Linked Accounts', href: `${url}/linkedAccounts` }
          ]}
          initialActiveTab={initialActiveTab}
        />
      </Box>
      <Box>
        <Switch>
          <Route exact path={path}>
            <Redirect to={{ pathname: `${url}/linkedCatalogs` }} />
          </Route>
          <Route exact path={`${path}/linkedCatalogs`}>
            <TableServerSideProvider
              tableId='linkedCatalogs'
              columnSortModifiers={columnSortModifiersLinkedCatalogs}
              columnFilterModifiers={columnFilterModifiersLinkedCatalogs}
            >
              <LinkedCatalogs catalogTypeId={catalogTypeId} />
            </TableServerSideProvider>
          </Route>
          <Route exact path={`${path}/linkedAccounts`}>
            <TableServerSideProvider
              tableId='linkedAccounts'
              columnSortModifiers={columnSortModifiersLinkedAccounts}
              columnFilterModifiers={columnFilterModifiersLinkedAccounts}
            >
              <LinkedAccounts catalogTypeId={catalogTypeId} />
            </TableServerSideProvider>
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};

LinkedCatalogsAndAccounts.propTypes = {
  catalogTypeId: string.isRequired
};

export default LinkedCatalogsAndAccounts;
